(ns app.front.view.property.v2.additional-addresses-section
  (:require ["@carbon/icons-react/es/add/16" :default Add16]
            [app.domain.property.model :as property-model]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.util :as futil]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.workspace.address :as ws-address]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]))

(defn- add-address-modal [tr property]
  (let [property-id   (:db/id property)
        municipality  (:property/municipality property)
        parse-address (<sub [::ws-address/parser (keyword (:municipality/subdivision municipality))])
        close-modal   #(>evt [::property-subs/set-add-address-modal-open false])
        saving?       (<sub [:comm/command-processing? :property/add-address])
        address       (<sub [::property-subs/add-address])
        valid?        (some-> address str/trim seq)]
    [ui-modal/composed-input-modal
     {:open                   true
      :size                   :sm
      :selector-primary-focus "#add-additional-address-input"
      :on-close               close-modal}
     (cc/modal-header
       {:close-modal close-modal
        :title       (tr [:property/add-additional-address-modal-title])})
     (cc/modal-body
       [:div.space-y-4
        [:p.text-sm.text-gray-600 (tr [:property/add-additional-address-description])]
        [:div
         [ui/text-input
          {:id         "add-additional-address-input"
           :label-text (tr [:workspace/address])
           :value      address
           :on-change  (fn [e]
                         (>evt [::property-subs/set-add-address (futil/tval e)]))}]]])
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :secondary
          :on-click close-modal}
         (tr [:cancel]))
       (cc/button
         {:kind     :primary
          :disabled (or (not valid?) (boolean saving?))
          :on-click #(>evt [::property-subs/add-additional-address property-id address parse-address])}
         (if saving? (tr [:saving]) (tr [:property/add-address]))))]))

(defn additional-addresses-section [{:keys [tr property]}]
  (let [property-id         (:db/id property)
        can-write-property? (-> property :granted-permissions :permission.property/write boolean)
        addl-addrs          (property-model/additional-addresses property)
        address-ids-in-use  (<sub [::property-subs/address-ids-in-use])]
    [:div
     (when can-write-property?
       [:div.flex.justify-end.mb-4
        [ui/button {:kind     :primary
                    :size     :small
                    :icon     Add16
                    :on-click #(>evt [::property-subs/set-add-address-modal-open true])}
         (tr [:property/add-address])]])

     [sortable-table/table
      {:id                "property-additional-addresses"
       :cols              [[(tr [:property-view/address])
                            (fn [item]
                              [:div
                               (or (:address/full-address item) "-")
                               (when (and (ff/enabled? :feature-flag.id/property-multiple-addresses)
                                          (contains? address-ids-in-use (:db/id item)))
                                 [:p.text-sm (tr [:property/address-in-use])])])
                            {:flex      "2 1 200px"
                             :min-width "180px"
                             :sort-key  :address/full-address
                             :sorting   #(sortable-table/compare-tr tr
                                                                    (:address/full-address %1)
                                                                    (:address/full-address %2))}]
                           [(tr [:property-view/state])
                            (fn [item]
                              (let [s (or (:domain/state item)
                                          :address.state/active)]
                                (tr [s])))
                            {:flex      "0 0 140px"
                             :min-width "120px"
                             :sort-key  :domain/state
                             :sorting   #(sortable-table/compare-tr tr
                                                                    (:domain/state %1)
                                                                    (:domain/state %2))}]]
       :make-actions      (when can-write-property?
                            (fn [addr]
                              (let [addr-id (:db/id addr)]
                                (cond-> [{:title           (tr [:property/set-as-primary-address])
                                          :confirm?        true
                                          :confirm-content (tr [:property/set-as-primary-confirm])
                                          :on-click        #(>evt [::property-subs/set-primary-address property-id addr-id])}]
                                  (= (:domain/state addr) :address.state/unverified)
                                  (conj {:title           (tr [:property/verify-address])
                                         :confirm?        true
                                         :confirm-content (tr [:property/verify-address-confirm])
                                         :on-click        #(>evt [::property-subs/verify-address property-id addr-id])})
                                  (and (not (contains? address-ids-in-use addr-id))
                                       (ff/enabled? :feature-flag.id/property-multiple-addresses))
                                  (conj {:title           (tr [:property/remove-address])
                                         :data-cy         "remove-property-address"
                                         :confirm?        true
                                         :confirm-content (tr [:property/remove-address-confirm]
                                                              [(:address/full-address addr)])
                                         :on-click        #(>evt [::property-subs/remove-address property-id addr-id])})))))
       :get-status        #(case (:domain/state %)
                             :address.state/unverified :warning
                             :address.state/active :ok
                             nil)
       :initial-sorting   [:address/full-address :asc]
       :empty-placeholder (tr [:property-view/no-additional-addresses])
       :id-func           :db/id
       :items             addl-addrs
       :tr                tr}]

     (when (<sub [::property-subs/add-address-modal-open?])
       [add-address-modal tr property])]))
